var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEuropeTripPlaneGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#3A3F46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.613 29.1064C61.3954 28.0839 56.7198 30.3844 54.9092 31.6625L66.4118 36.2953C67.9029 34.325 69.8306 30.1288 65.613 29.1064Z",
    fill: "#9DA4AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9202 41.2479C59.7337 25.0165 32.9688 31.3962 21.3597 36.6149C19.4426 34.0587 16.7267 30.0117 15.6084 28.3077C12.2854 27.4131 7.72699 28.6805 5.86314 29.426C5.22411 38.2127 12.2535 53.5496 14.6499 54.9874C17.0462 56.4252 40.8502 58.1825 51.8736 58.6618C60.6923 59.0452 69.8198 55.4134 73.2812 53.5496C75.7309 52.8573 80.694 50.8017 80.9496 48.1178C81.2052 45.4338 76.3699 42.4196 73.9202 41.2479Z",
    fill: "#F1F2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7978 53.1766C71.7808 49.4355 72.9884 44.3759 73.8627 41.8459C73.9773 41.5144 74.3448 41.3541 74.6612 41.5055C77.3101 42.7731 81.5059 46.0543 80.9496 48.2794C80.2399 51.1183 75.9176 52.9445 73.5044 53.5808C73.1955 53.6622 72.8817 53.4848 72.7978 53.1766Z",
    fill: "#9DA4AF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7075 45.3172C71.301 48.9846 59.3158 51.2781 46.0131 51.2781C30.5728 51.2781 16.9073 48.1883 8.55273 43.4465C10.6252 49.2263 13.3348 54.1995 14.6496 54.9884C17.046 56.4263 40.85 58.1836 51.8734 58.6629C60.692 59.0463 69.8196 55.4145 73.281 53.5506C75.7306 52.8583 80.6938 50.8028 80.9494 48.1188C81.0374 47.1945 80.5217 46.2311 79.7075 45.3172Z",
    fill: "#D5D8DD"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.193 50.1933C50.5554 48.4349 40.7075 47.8696 35.8699 47.8001C35.7069 47.7977 35.5566 47.856 35.4379 47.9678C30.1137 52.9806 20.0039 62.9885 20.762 64.252C21.7206 65.8496 24.117 65.8496 28.1109 65.5301C32.1049 65.2105 56.5479 52.4299 53.193 50.1933Z",
    fill: "#9DA4AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0108 33.2588C13.7551 32.7476 9.85704 32.1937 7.93994 31.9807C5.17079 33.525 1.98962 36.5942 3.30694 37.2527C5.22429 38.2113 14.3303 33.8978 14.0108 33.2588Z",
    fill: "#9DA4AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1233 45.8712C69.5367 43.9671 71.8544 42.4412 73.2659 41.5178C73.6035 41.2969 73.6424 40.8229 73.349 40.5459L71.0445 38.3694L68.387 36.4113C68.1627 36.246 67.8572 36.2461 67.637 36.4169C66.0681 37.6342 63.494 39.8645 63.3761 40.9256C63.2629 41.9441 65.563 44.4573 67.1266 45.9809C67.4139 46.2609 67.8842 46.1933 68.1233 45.8712Z",
    fill: "#9DA4AF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.0981,
    cy: 43.9641,
    rx: 2.55614,
    ry: 2.55614,
    fill: "#9DA4AF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.7671,
    cy: 43.9641,
    rx: 2.55614,
    ry: 2.55614,
    fill: "#9DA4AF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.0747,
    cy: 43.9641,
    rx: 2.55614,
    ry: 2.55614,
    fill: "#9DA4AF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEuropeTripPlaneGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EuropeTripPlaneGray.dc5101db9b47b876deb1338548ed1997.svg";